// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

// Components
import Button from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';
import FilterButtonDropdown from 'app/shared/modules/MobileSRP/__BaseComponents__/FilterButtonDropdown';
import PetFilter from 'app/shared/modules/MobileSRP/Header/FilterModules/PetFilter';

const DEFAULT_LABEL = 'Pets';
const PetFilterButton = ({ ariaButtonLabel, ariaDropdownLabel, onButtonClick, onModalClose, showDropdown }) => {
  // Redux
  const petState = useSelector((state) => state.filter.pets);

  // All filter buttons should have this ref to return focus after user has closed the filter modal
  const focusRef = useRef(null);
  const isLoaded = useRef(null);

  useEffect(() => {
    /**
     * isLoaded is a component instance variable. Do not set focus on the button until
     * after the component has been interacted with.
     * @see: https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
     */
    if (!isLoaded.current) {
      isLoaded.current = true;
    } else {
      if (!showDropdown) {
        focusRef.current.focus();
      }
    }
  }, [showDropdown]);

  const getButtonLabel = () => {
    const { cats, dogs } = petState;

    if (cats && dogs) {
      return 'Dogs, Cats';
    } else if (cats && !dogs) {
      return 'Cats';
    } else if (!cats && dogs) {
      return 'Dogs';
    }

    return DEFAULT_LABEL;
  };

  const getButtonStatus = (label) => {
    return label !== DEFAULT_LABEL;
  };

  const buttonLabel = getButtonLabel();
  const isFilterActive = getButtonStatus(buttonLabel);

  return (
    <>
      <Button
        ariaLabel={ariaButtonLabel}
        ariaExpanded={showDropdown}
        active={isFilterActive}
        onClick={onButtonClick}
        ref={focusRef}
        showCarat
      >
        {buttonLabel}
      </Button>
      {showDropdown && (
        <FilterButtonDropdown ariaLabel={ariaDropdownLabel} dropdownId={'pet-filter-dropdown'} onClose={onModalClose}>
          <PetFilter showResetButton />
        </FilterButtonDropdown>
      )}
    </>
  );
};

export default PetFilterButton;
